import Modal from "react-modal";
import { ModalTitle } from "styles/Modal";
import closeImg from "../../assets/close.svg";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { InputGroup } from "styles/InputGroup";
import { Button } from "styles/Button";
import { Form } from "styles/Form";
import { Buttons } from "components/MessageForm/styles";
import { Input } from "components/Form/Input";
import { useEditSupportAgent } from "hooks/mutations/useEditSupportAgent";
import { SupportAgent } from "types/SupportAgent";
import { useEffect } from "react";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  agent: SupportAgent;
};

export function EditSupportAgentModal({ isOpen, onRequestClose, agent }: Props) {
  const { handleSubmit, control, reset, setValue, formState: { isSubmitting } } = useForm<FieldValues>({
    defaultValues: { weight: 1 },
  });

  const editAgent = useEditSupportAgent();

  useEffect(() => {
    setValue('weight', agent.weight);
  }, [agent, setValue]);

  function handleClose() {
    reset();
    onRequestClose();
  }

  async function handleSubmitForm({ weight }: any) {
    await editAgent.mutateAsync({ agent, data: { weight: Number(weight) } });
    handleClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content"
    >
      <button type="button" onClick={handleClose} className="react-modal-close">
        <img src={closeImg} alt="Fechar modal" loading="lazy" />
      </button>

      <div>
        <ModalTitle>Editar — {agent.user?.name}</ModalTitle>
        <Form onSubmit={handleSubmit(handleSubmitForm as SubmitHandler<FieldValues>)}>
          <InputGroup>
            <Input
              control={control}
              type="number"
              name="weight"
              id="weight"
              label="Peso (1–100)"
              min={1}
              max={100}
              fullwidth
            />
          </InputGroup>

          <InputGroup>
            <Buttons>
              <Button type="submit" fullwidth disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </Button>
              <Button type="button" onClick={handleClose}>Cancelar</Button>
            </Buttons>
          </InputGroup>
        </Form>
      </div>
    </Modal>
  );
}
